import { apiRoutes } from '../../../constants/apiRoutes.ts';
import { useListApi } from '../../../util/useListApi.tsx';
import { Box, Image, Skeleton } from '@chakra-ui/react';
import { Banner } from '../../bannerAdmin/types.ts';
import { Carousel } from 'react-responsive-carousel';
import 'react-responsive-carousel/lib/styles/carousel.min.css';

export const AuctionBanner = () => {
  const route = apiRoutes.crm.banners.base;
  const api = useListApi<Banner>('Banner', route);
  const banners = api.list(0, 1000, false);

  if (banners.isLoading) {
    return (
      <Box w='100%' h='230px' overflow='hidden' position='relative'>
        <Skeleton height={230} />
      </Box>
    );
  }

  return (
    <Box w='100%'>
      <Carousel
        autoPlay={true}
        infiniteLoop={true}
        interval={10000}
        showIndicators={false}
        showArrows={false}
        autoFocus={true}
        showStatus={false}
        showThumbs={false}>
        {banners.data?.PagedRows.filter((banner) => banner.Active).map((banner, index) => (
          <Box key={index} w='100%' h='230px' overflow='hidden' position='relative'>
            <Image src={banner.ImageUrl} alt={banner.Name} objectFit='cover' w='100%' h='100%' />
          </Box>
        ))}
      </Carousel>
    </Box>
  );
};
